'use client';
'use strict';

var classes = {"dropdown":"m-dc9b7c9f","label":"m-9bfac126","divider":"m-efdf90cb","item":"m-99ac2aa1","itemLabel":"m-5476e0d3","itemSection":"m-8b75e504"};

module.exports = classes;
//# sourceMappingURL=Menu.module.css.cjs.map
